import "./src/styles/global.css"

// Define the routes where you want to fix the scroll position
const fixedScrollRoutes = [
  "/company",
  "/extractionSite",
  "/building",
  "/product",
  "/material",
  "/groupOfTechnic",
  "/technic",
  "/list",
]
const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}
console.log(isSafari(),"isSafari")
const isFixedScrollRoute = (pathname) => {
  return fixedScrollRoutes.some((route) => pathname.startsWith(route))
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const { pathname } = location

  // Check if the current route matches any of the fixed scroll routes
  if (isFixedScrollRoute(pathname)) {
    // Retrieve the saved scroll position for the current location
    const currentPosition = getSavedScrollPosition(location)

    // If there is a saved position, scroll to that position
    // Otherwise, scroll to the top of the page
    if (currentPosition) {
      window.scrollTo(...currentPosition)
    } else {
      window.scrollTo(0, 0)
    }

    // Returning false prevents the default scroll behavior
    return false
  }

  // For other routes, allow the default scroll behavior
  return true
}

// To save the scroll position before navigating away
export const onPreRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    const { pathname } = prevLocation

    // Check if the previous route matches any of the fixed scroll routes
    if (isFixedScrollRoute(pathname)) {
      const scrollPosition = [window.scrollX, window.scrollY]
      sessionStorage.setItem("scrollPosition", JSON.stringify(scrollPosition))
    }
  }
}

// To restore the scroll position after the route update
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    const { pathname } = prevLocation

    // Check if the previous route matches any of the fixed scroll routes
    if (isFixedScrollRoute(pathname)) {
      const scrollPosition = JSON.parse(
        sessionStorage.getItem("scrollPosition")
      ) || [0, 0]

      // Apply delay only for Safari
      if (isSafari()) {
        setTimeout(() => {
          window.scrollTo(...scrollPosition)
        }, 50)
      } else {
        window.scrollTo(...scrollPosition)
      }
    }
  }
}
